import React from "react";
import ProductCard from "../components/ProductCard";
import Layout from "../components/Layout";
import styles from "./Sprats.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const liverProducts = [
  // --- VALMIS DeLuxe ---
  { key: "valmis_tl_230", image: "/assets/products/canned/liver/liver-valmis-tl-230.jpg" },
  { key: "valmis_121", image: "/assets/products/canned/liver/liver-valmis-121.jpg" },
  { key: "valmis_tl_115", image: "/assets/products/canned/liver/liver-valmis-tl-115.jpg" },
  { key: "valmis_230", image: "/assets/products/canned/liver/liver-valmis-230.jpg" },

  // --- Baltic Sea PREMIUM ---
  { key: "baltic_230", image: "/assets/products/canned/liver/liver-baltic-sea-230.jpg" },
  { key: "baltic_tl_230", image: "/assets/products/canned/liver/liver-baltic-sea-tl-230.jpg" },
  { key: "baltic_121", image: "/assets/products/canned/liver/liver-baltic-sea-121.jpg" },
];

const Liver = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("liver.title")}</h2>

      <div className={styles.grid}>
        {liverProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`liver.products.${product.key}.title`)}
            weight={t(`liver.products.${product.key}.weight`)}
            description={t(`liver.products.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Liver;
